import Loadable from "../utils/loadable";

export const Home = Loadable(() =>
  import(/* webpackChunkName: "Home" */ "./Home/Home")
);

export const Sidebar = Loadable(() =>
  import(/* webpackChunkName: "SideBar" */ "../containers/Sidebar/Sidebar")
);

export const Breadcrumb = Loadable(() =>
  import(/* webpackChunkName: "Breadcrumb" */ "./Breadcrumb/Breadcrumb")
);
